// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8b3b24ab","160":"8e950497","208":"3c8ed66e","293":"28e5e15a","455":"a9ba13ed","516":"2ce4073d","519":"3d60e31b","840":"535aef79","917":"d74b5e98","946":"8b264d65","977":"240addac"}[chunkId] + ".chunk.js";
};